import React from 'react';
import { NoResults } from './NoResults/NoResults';
import { GenericCard } from './cards/GenericCard/GenericCard';

const Results = ({ results, resourcedTexts, searchTerm, viewType }) => {
    const gridClass = 'sfr-results__grid';
    let gridClasses = '';
    if (viewType === 'list') gridClasses = gridClass + ' ' + gridClass + '--list';
    else if (viewType === 'grid-large') gridClasses = gridClass + ' ' + gridClass + '--large';
    else gridClasses = gridClass + ' ' + gridClass + '--medium';

    return (
        <div className="sfr-results">
            {!results.length ? (
                <NoResults searchTerm={searchTerm} resourcedTexts={resourcedTexts} />
            ) : (
                <div className={gridClasses}>
                    {results.map((resultItem, index) => (
                        <div className="sfr-results__grid-item" key={index}>
                            <GenericCard resourcedTexts={resourcedTexts} {...resultItem} />
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export { Results };
